var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/send-one"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5232 2.46263C21.7309 2.66479 21.8034 2.96847 21.7097 3.24267L15.2123 22.2427C15.1047 22.5571 14.8031 22.7633 14.4711 22.7493C14.139 22.7353 13.8558 22.5045 13.7751 22.1821L11.3885 12.6497L1.85754 10.8055C1.52751 10.7416 1.28028 10.466 1.25257 10.131C1.22486 9.79596 1.42344 9.48343 1.73849 9.36622L20.7385 2.29707C21.0101 2.19601 21.3156 2.26047 21.5232 2.46263ZM4.76566 9.84038L12.1425 11.2678C12.4286 11.3232 12.6568 11.5393 12.7276 11.822L14.6139 19.3566L19.7783 4.25478L4.76566 9.84038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3626 8.64542C15.6555 8.93831 15.6555 9.41319 15.3626 9.70608L12.5342 12.5345C12.2413 12.8274 11.7665 12.8274 11.4736 12.5345C11.1807 12.2416 11.1807 11.7667 11.4736 11.4738L14.302 8.64542C14.5949 8.35253 15.0697 8.35253 15.3626 8.64542Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.d1b5e54e3fb0b5df8f10ea42531db507.svg";
export { ForwardRef as ReactComponent };